module.exports = "query IssueFormQuery{issueUploadRoute:route(name:\"issue_upload\"){url}}"